import NavHeader from "../shared/Nav-Header";
import styles from "./notification.module.css";

const NotificationPage = () => {
  return (
    <div>
        <NavHeader />
        <h1>Notifications</h1>
        
        </div>
  );
}
export default NotificationPage;